export default __webpack_public_path__ + "static/media/sent.23a7e611.png";